import SocialMediaContainer from './container';

export default SocialMediaContainer;
